module.exports = __webpack_public_path__ + "static/What-is-a-mockup-Mockups-explained-2527f5badfdcde7545e57aff61dfc5aa.png";